import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useGetApiTutorialDocToken } from '@/api/documentation/documentation.hooks';
import { getApiBaseUrl } from '@/api/getApiBaseUrl';
import { ERoutes } from '@/types/routes';
import { ITopNavigationProps } from '@/layouts/MainLayout/components/Sidebar/components/TopNavigation/TopNavigation';

export const useSidebarManager = ({
  handleMenuToggle,
}: Pick<ITopNavigationProps, 'handleMenuToggle'>) => {
  const navigate = useNavigate();
  const { fetchApiTutorialDocToken } = useGetApiTutorialDocToken();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [mouseOverButton, setMouseOverButton] = useState<boolean>(false);
  const [mouseOverMenu, setMouseOverMenu] = useState<boolean>(false);
  const open = mouseOverButton || mouseOverMenu;

  const handleDocumentationMenuClose = () => {
    setMouseOverButton(false);
    setMouseOverMenu(false);
  };

  const handleEnterDocumentationButton = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!mouseOverButton) {
      setMouseOverButton(true);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleLeaveDocumentationButton = () => {
    setTimeout(() => {
      setMouseOverButton(false);
    }, 1000);
  };

  const handleEnterDocumentationMenu = () => {
    if (!mouseOverMenu) {
      setMouseOverMenu(true);
    }
  };

  const handleLeaveDocumentationMenu = () => {
    setTimeout(() => {
      setMouseOverMenu(false);
    }, 100);
  };

  const handleMenuOptionClick = (variant: 'documentation' | 'apiDocs') => {
    handleDocumentationMenuClose();
    handleMenuToggle();

    if (variant === 'documentation') {
      navigate(ERoutes.DOCUMENTATION);
    }

    if (variant === 'apiDocs') {
      const newWindow = window.open('', '_blank');
      fetchApiTutorialDocToken(undefined, {
        onSuccess: ({ token }) => {
          const baseUrl = getApiBaseUrl();
          if (newWindow) {
            newWindow.location.href = `${baseUrl}/documentation/api-tutorial?token=${token}`;
          }
        },
        onError: error => {
          console.error(error);
          newWindow?.close();
        },
      });
    }
  };

  return {
    open,
    anchorEl,
    handleDocumentationMenuClose,
    handleMenuOptionClick,
    handleEnterDocumentationButton,
    handleLeaveDocumentationButton,
    handleEnterDocumentationMenu,
    handleLeaveDocumentationMenu,
  };
};
